import axios from 'axios'
import load from "@/LOAD.js";
import store from "@/store/index.js"
import storage from "./storage.js"

const instance = axios.create({

    baseURL: load.getUrlApi(),
});

// Contatore richieste in corso: mostra la progress bar globale finché almeno
// una chiamata è pendente (evita che due chiamate in parallelo si "chiudano"
// a vicenda la barra). Le chiamate con loadingBar:false restano silenziose.
let pendingRequests = 0

function startLoading(config) {
    if (config && config.loadingBar === false) return
    pendingRequests++
    if (pendingRequests === 1) store.commit('app/SET_LOADING', true)
}

function stopLoading(config) {
    if (config && config.loadingBar === false) return
    pendingRequests = Math.max(0, pendingRequests - 1)
    if (pendingRequests === 0) store.commit('app/SET_LOADING', false)
}

// ----------------------------------
// ------------ REQUEST -------------
// ----------------------------------
instance.interceptors.request.use(config => {

    startLoading(config)

    // Imposto il token
    if (store.getters['auth/isAuthenticated'])
        config.headers.Authorization = storage.getAuthHeader()

    return config

}, function (error) {

    // Request error
    console.log("request interceptor " + error)

    return Promise.reject(error)
})


// ----------------------------------
// ------------ RESPONSE ------------
// ----------------------------------
instance.interceptors.response.use(response => {

    stopLoading(response.config)

    return response

}, function (error) {

    stopLoading(error.config)

    let originalRequest = error.config


    // Controllo scadenza token
    if (error.response && error.response.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true
        return store.dispatch("auth/refreshToken").then(authResponse => {
            instance.defaults.headers.common['Authorization'] = 'Bearer ' + authResponse.data.access_token;
            originalRequest.headers['Authorization'] = 'Bearer ' + authResponse.data.access_token
            return instance(originalRequest)
        }).catch(err => {
            // Refresh token assente/non valido: la sessione non è più recuperabile,
            // si esce e si torna al login invece di lasciare l'app in uno stato inconsistente
            storage.logout()
            return Promise.reject(err)
        });
    }

    if (error.response) {
        const status = error.response.status
        const data = error.response.data

        // 400 = errore controllato dal backend con messaggio leggibile
        // 500 (o altro) = eccezione non gestita → messaggio generico
        const isUserMessage = status === 400
            && typeof data === 'string'
            && data.trim() !== ''

        const messaggio = isUserMessage
            ? data
            : 'Errore imprevisto. Riprova più tardi.'

        store.commit('app/showMessage', { testo: messaggio, tipo: 'error' })
    } else {
        // Nessuna risposta dal server: rete assente, timeout o server irraggiungibile
        store.commit('app/showMessage', { testo: 'Connessione al server non disponibile. Controlla la connessione e riprova.', tipo: 'error' })
    }

    return Promise.reject(error);

})

export default instance